<div class="modal-header py-2 bg-light">
  <h5 class="modal-title">
    <i class="ph ph-file-xls me-2"></i>
    {{ options.title ? options.title : 'common.exportExcel' | transloco }}
  </h5>

  <button type="button" data-bs-dismiss="modal" (click)="activeModal.dismiss()" aria-label="Close" class="btn-close"></button>
</div>
<div class="modal-body" *transloco="let t">
  <div class="form-group mb-2 row">
    <div class="col-2 my-0">
      <label class="form-label fw-semibold">
        <i class="ph ph-file fs-5 me-2"></i>
        {{ t('common.selectData') }}:
      </label>
    </div>
    @if (options.excelListPage) {
      <div class="col-10 my-0 row">
        @for (page of options.excelListPage.list; track page) {
          <div class="col-4">
            <app-checkbox
              [options]="{
 componentType: 'form-switch',
 type: 'radio',
 name: 'isListPages',
 color: 'success'
 }"
              [value]="page.key"
              [label]="page.value"
              [checked]="page.key == states.excelPageChecked"
              (valueChange)="states.excelPageChecked = $event"
            />
          </div>
        }
      </div>
    }
  </div>

  @if (states.settingColumns.length) {
    <div class="form-group mb-2 row">
      <div class="col-2 my-0">
        <label class="form-label fw-semibold">
          <i class="ph ph-columns fs-5 me-1"></i>
          {{ t('common.messages.selectColumn') }}:
        </label>
      </div>
      <div class="col-10 my-0 row">
        <div class="col-4">
          <app-checkbox
            [options]="{
 componentType: 'form-switch',
 type: 'radio',
 name: 'columnExcelOption',
 color: 'success'
 }"
            [value]="'all'"
            [label]="t('common.all')"
            [checked]="states.columnExcelOption == 'all'"
            (valueChange)="states.columnExcelOption = $event"
          />
        </div>
        <div class="col-4">
          <app-checkbox
            [options]="{
 componentType: 'form-switch',
 type: 'radio',
 name: 'columnExcelOption',
 color: 'success'
 }"
            [value]="'column'"
            [label]="t('common.elective')"
            [checked]="states.columnExcelOption == 'column'"
            (valueChange)="states.columnExcelOption = $event"
          />
        </div>
        @if (options.exportFacebook) {
          <div class="col-4">
            <app-checkbox
              [options]="{
 componentType: 'form-switch',
 type: 'radio',
 name: 'columnExcelOption',
 color: 'success'
 }"
              [value]="options.exportFacebook.value"
              [label]="options.exportFacebook.name"
              [checked]="states.columnExcelOption == options.exportFacebook.value"
              (valueChange)="states.columnExcelOption = $event"
            />
          </div>
        }
      </div>
    </div>
  }

  @if (options.recordAllFullPage) {
    <div class="form-group mb-2 cursor-pointer">
      <app-checkbox
        [value]="true"
        [checked]="states.recordAllFullPage"
        [label]="options.recordAllFullPage"
        (valueChange)="states.recordAllFullPage = $event"
      />
    </div>
  }

  @if (states.settingColumns.length) {
    <div class="dropdown-divider border-bottom"></div>
    @if (states.columnExcelOption == 'column') {
      <div class="scrollbar-columns mb-2">
        <div class="check-all mb-2">
          <div class="col-4 form-switch">
            <input type="checkbox" id="colAll"
                   class="form-check-input me-2 cursor-pointer"
                   [checked]="states.colsAll" (click)="onCheckAll()">
            <label class="form-check-label cursor-pointer" for="colAll">
              {{ t('common.allColumns') }}
            </label>
          </div>
        </div>
        <div class="row">
          @for (col of states.settingColumns; track col) {
            <div class="group-columns col-3 mb-2">
              <app-checkbox
                [options]="{ color: 'info', componentType: 'form-switch' }"
                [value]="1"
                [label]="col.nameOriginal ? col.nameOriginal : t(col.name)"
                [checked]="col.display"
                (valueChange)="colChange($event, col)"
              />
            </div>
          }
        </div>
      </div>
      <div class="dropdown-divider border-bottom"></div>
    }
  }

  @if (options.typeExcelSetting) {
    <div class="form-group mt-2 mb-2">
      <app-checkbox
        [value]="1"
        [label]=" t('order.saveThisSettingLater')"
        [checked]="states.rembExcelSetting"
        (valueChange)="states.rembExcelSetting = $event"
      />
    </div>
  }

  @if (states.isSubmit) {
    <div class="row">
      <div class="col-lg-6">
        <p class="mb-2">
          <span class="ph ph-gear excel-loading-icon me-2"></span>
          {{ t('common.exportingData') }}:
          <span class="currentItem">{{ progresState.currentItem }}</span> /
          <span class="totalItems">{{ progresState.totalItems }}</span>
        </p>
      </div>
      <div class="col-12">
        <app-progress-bar [totalPages]="progresState.totalPages" [currentPage]="progresState.currentPage"/>
      </div>
    </div>
  }

  <div class="d-flex justify-content-end mt-3">
    <button [disabled]="states.isSubmit" class="btn btn-success btn-sm" (click)="onExportData()">
      {{ t('common.exportData') }}
    </button>
  </div>
</div>
